<template>
  <div>
    <v-layout>
      <v-flex xs12 sm6> Theme </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <v-progress-circular v-if="isLoading" indeterminate color="primary" />
        <template v-else>
          <v-autocomplete
            v-model="input"
            outline
            single-line
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            hide-selected
            placeholder="Theme"
          ></v-autocomplete>
        </template>
      </v-flex>
    </v-layout>
    <div class="text-xs-center mt-2 mb-2">
      <v-btn outline color="grey" @click="$emit('onCancel')">{{ $t('cancel') }} </v-btn>
      <v-btn depressed color="primary" @click="$emit('onChangeConfig', input)"
        >{{ $t('Save') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import pageConfigApi from '@/api/page-config'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isEdit: false,
      limit: 1000,
      offset: 0,
      isLoading: true,
      search: null,
      items: [],
      input: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  // watch: {
  //   search(val) {
  //     // Items have already been requested
  //     if (this.isLoading) return
  //     this.isLoading = true
  //     this.offset = 0
  //     this.handleGetThemeList()
  //     this.isLoading = false
  //   }
  // },
  async mounted() {
    this.input = this.selectedBot.theme
    this.isLoading = true
    this.handleGetThemeList()
    this.isLoading = false
  },
  methods: {
    async handleGetThemeList() {
      try {
        const params = {
          limit: this.limit,
          offset: this.offset,
          page_id: this.selectedBot.pageid,
          theme: this.search ? this.search : undefined
        }
        const response = await pageConfigApi.getThemeList({
          params
        })
        if (response.status == 200 && response.data && response.data.data) {
          const data = response.data.data
          this.items = data.map((item) => {
            return {
              text: item.theme,
              value: item.theme
            }
          })
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdvancedSetting/ThemeConfigManage.vue